<template>
	<el-dialog :title="row.name" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
		<span v-if="row.type == 'image'">圖片支援上傳jpg/jpeg/png/gif格式且大小不得超過20M, 單次最多支援上傳20個素材</span>
		<span v-if="row.type == 'video'">影片支援上傳mp4/ogg/avi/mov/webm格式且大小不得超過60M, 單次最多支援上傳20個素材</span>
		<span v-if="row.type == 'music'">音訊支援上傳ogg/mp4/mp3/m4a/wav格式且大小不得超過10M, 長度不超過60s, 單次最多支援上傳20個素材</span>
		<span v-if="row.type == 'file'">附件支援上傳檔案大小不得超過50M, 單次最多支援上傳20個素材</span>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			<!-- :on-success="handleSuccess" :on-error="handleError" -->
			<el-upload class="upload-demo" style="margin-left: 10px;" multiple action="" :limit="20"
				:http-request="customUpload" :show-file-list="false" :file-list="fileList">
				<el-button size="small" type="primary">点击上传</el-button>
			</el-upload>
			<!-- <el-button type="primary" @click="upload">点击上传</el-button> -->
		</span>
	</el-dialog>

</template>

<script>
	import {
		uploadFile
	} from '@/utils/upload'
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			row: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				// dialogVisible: false,
				setObj: {},
				fileList: []
			};
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			},
		},
		watch: {
			// type: {
			// 	immediate: true,
			// 	handler(val) {
			// 		if (val) {
			// 			let obj2 = {
			// 				title: '话术库'
			// 			}
			// 			let obj1 = {
			// 				title: '分类'
			// 			}
			// 			this.setObj = val == 1 ? obj1 : obj2
			// 		}
			// 	}
			// }
		},
		methods: {
			handleClose() {
				this.$emit('update:visible', false)
				// this.$confirm('确认？')
				// 	.then(() => {
				// 		done();
				// 		this.$emit('update:visible', false)
				// 	})
				// 	.catch(() => {});
			},
			async customUpload({
				file
			}) {
				uploadFile(file).then(res => {
					if (res.code == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						let josn = {
							path: res.data.url,
							type: this.row.value,
							filename: res.data.filename,
							format: res.data.imagetype,
							filesize: res.data.filesize,
						}
						this.$axios.post(this.$apis.addMaterial, josn).then(res => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.$emit('getList')
								this.$emit('update:visible', false)
							} else {
								this.$message.error(res.msg);
							}
						})

					} else {
						this.$message.error(res.msg);
					}
				})
			},
		},
		mounted() {}
	};
</script>

<style lang="scss" scoped>
	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
</style>